// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-size{width:90px;height:90px}.icon-size1{width:90px;height:116px}", ""]);
// Exports
module.exports = exports;
